import React from 'react';

const COLS = [
  { title: 'Product',  links: [
    { label: 'Showcase',   href: '#showcase' },
    { label: 'Use Cases',  href: '#use-cases' },
    { label: 'Privacy',    href: '#privacy' },
  ] },
  { title: 'Company',  links: [{ label: 'Powered by SIMTECH AI', href: '#' }] },
  { title: 'Formats',  links: [
    { label: 'MP3 · WAV · M4A', href: '#' },
    { label: 'MP4 · MOV',       href: '#' },
    { label: 'YouTube · Podcast', href: '#' },
  ] },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="pt-10 pb-8 border-t border-white/5 relative">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="grid md:grid-cols-[1.4fr_repeat(3,1fr)] gap-10">
          <div>
            <img src="/simnopsis-logo.png" alt="SIMNOPSIS" className="h-8 w-auto mb-3" />
            <div className="font-display text-white/90 text-lg leading-snug max-w-xs">
              Hours of Audio. <span className="text-grad">Insights in Seconds.</span>
            </div>
            <div className="mt-4 font-mono text-[10px] uppercase tracking-widest text-white/40">
              Powered by SIMTECH AI
            </div>
          </div>
          {COLS.map(col => (
            <div key={col.title}>
              <div className="font-mono text-[10px] uppercase tracking-widest text-white/40 mb-3">{col.title}</div>
              <ul className="space-y-2">
                {col.links.map(l => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="text-sm text-white/70 hover:text-white transition-colors"
                      onClick={(e) => {
                        if (l.href.startsWith('#') && l.href.length > 1) {
                          e.preventDefault();
                          document.getElementById(l.href.slice(1))?.scrollIntoView({ behavior: 'smooth' });
                        }
                      }}
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-8 pt-5 border-t border-white/5 flex flex-wrap items-center justify-between gap-3">
          <span className="text-xs text-white/40">© 2026 Simtech X</span>
          <span className="font-mono text-[10px] uppercase tracking-widest text-white/30">
            ⌨ Space to play · 1/2/3 for tabs · Esc to reset
          </span>
        </div>
      </div>
    </footer>
  );
}
